import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

/** 单笔/批量厂家直采 */
export function postPurchaseBat(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/purchase/bat", data || {})
}

/** 取消未付采购 */
export function postPurchaseCancel(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/purchase/cancel", data || {})
}

/** 已付撤销造 B */
export function postPurchaseRepeal(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/purchase/repeal", data || {})
}

/** 待支付链接 / 重试免密 */
export function postPurchasePay(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/purchase/pay", data || {})
}

/** 软删订单商品行 */
export function postPurchaseDelete(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/purchase/delete", data || {})
}

/** 恢复软删 */
export function postPurchaseRestore(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/purchase/restore", data || {})
}
